<template>
  <body>  

     
    <div id="content">
      <iframe src="https://analytics.blubirch.com/home/#/opendocument?data=eyJ1c2VyIjoiMzI3NzUiLCJzcGFjZWtleSI6IjExMTEiLCJkb2NJZCI6IjQ4NDk2NzAiLCJhbGciOiJIUzI1NiIsInppcCI6IkdaSVAifQ.H4sIAAAAAAAAADWQy3KCMAAA_4VzcSCQpPYGgWigiNCC1RsEkPegQVE6_ffSQ_e2t539luqxkt4kDWAMpRdJ3NLF8qdTphte-ZXDopmpu4oJ1g8DJwyxJks-YqMqgtVWF8z4xwSeP10tzzQoxq5KQKfK1_b93AfuLhFFZxu8oZ6t43ELaTRHePp8VIVFupzchqKWge7E7SyP45cDvXPqgiNcdxmeT8yIEgcf3INl25TZDRoS2w_kEtM5OsJWJsRMjw_Yt8AJ76B2FO4imW1AGw2pH_YxoGjKQ4PWcTn9ha6KPdZUEyomyVCZ00YIG6XhBV8CeNoARp7WYe-zG71TZTlSCbEcQbzAaK0hpHOuJUmhIsyR8gpVnq-hlkHp5xeQ3j3KSgEAAA.V9nJ9u4YW0N5hukSyGeVoxRTXH-yqlgpQNYoyR__OVA"></iframe>
    </div>


</body>
</template>


<script>

  export default {
    name: 'managementDashboard'    
  }

</script>

<style media="screen" scoped>

iframe {

  border: none;
  height: 100vh;       
  width: 95vw;
  margin-left: -8px;
}
</style>


// WEBPACK FOOTER //
// src/components/api/v1/warehouse/dashboards/managementDashboard.vue